import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import RoutesConfig from "./All Routing/Routesconfig";
import { WindowProvider } from "./Context/WindowContext";

const App = () => {
  return (
    <div className="App">
      <WindowProvider>
        <RoutesConfig />
      </WindowProvider>
    </div>
  );
};

export default App;
